<div class="modal-header">
    <h2 class="modal-title">State Tax Exemption</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="stateTaxExemption" [formData]="stateTaxExemption" validationGroup="stateTaxExemptionValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="name">
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="url">
                        <dxi-validation-rule type="required"> </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" (click)="save()">Save</button>
    <button class="btn btn-success" (click)="close()">Close</button>
</div>
